<template>
	<div>
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="日期：">
				<el-date-picker
					v-model="inputDate"
					type="date"
					:default-value="new Date()"
					:clearable="false"
					value-format="yyyy-MM-dd"
					placeholder="选择日期"
					:editable="false"
					format="yyyy年MM月dd日"
					size="small"
					@change="changeDate"
				></el-date-picker>
			</el-form-item>
			<el-form-item style="float: right">
				<el-radio-group v-model="echartType" border @input="changeChartType">
					<el-radio-button label="category">柱状图</el-radio-button>
					<el-radio-button label="line">折线图</el-radio-button>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<div class="statisticChart"></div>
	</div>
</template>

<script>
import { GetStoreOrderDayStatistic } from "@/api/storeOrderApi.js";
import * as echarts from "echarts";
export default {
	data() {
		return {
			loading: false,
			statisticData: {
				storeList: [],
				num1List: [],
				num2List: [],
				num3List: []
			},
			formInline: {
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1,
				day: new Date().getDate()
			},
			echartType: "category",
			inputDate: new Date()
		};
	},
	components: {},

	created() {},

	mounted() {
		// First initialize the chart with proper sequence
		this.initChart();
		// Then load data
		this.GetStoreOrderDayStatistic(this.formInline);
	},

	methods: {
		// Switch chart type between bar and line
		changeChartType() {
			// Check if chart instance exists before operating
			if (!this.chart || this.chart.isDisposed()) {
				// If not, get container and create new instance
				const chartDom = document.querySelector(".statisticChart");
				if (chartDom) {
					this.chart = echarts.init(chartDom);
				} else {
					console.error("Chart container not found");
					return;
				}
			}

			const chartTitlePre = this.formInline.year + "年" + this.formInline.month + "月" + this.formInline.day + "日门店加工订单数量统计";
			// 根据图表类型设置配置
			const isBarChart = this.echartType === "category";
			const chartTitle = chartTitlePre + (isBarChart ? "柱状图" : "折线图");
			const chartType = isBarChart ? "bar" : "line";
			const axisPointerType = isBarChart ? "shadow" : "line";

			// 设置图表选项
			const option = {
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: axisPointerType
					}
				},
				title: {
					text: chartTitle,
					left: "center",
					textStyle: {
						color: "#333",
						fontSize: 18
					},
					top: "10px"
				},
				legend: {
					data: ["订单总数", "已完成数量", "撤单数量"],
					top: "40px",
					left: "center",
					textStyle: {
						color: "#666"
					},
					selectedMode: "multiple"
				},
				grid: {
					left: "2%",
					right: "5%",
					bottom: "2%",
					top: "100px",
					containLabel: true
				},
				xAxis: {
					name: "门店名称",
					type: "category",
					data: this.statisticData.storeList,
					axisLabel: {
						interval: 0,
						rotate: 30
					}
				},
				yAxis: {
					type: "value",
					name: "订单数量"
				},
				series: [
					{
						name: "订单总数",
						type: chartType,
						data: this.statisticData.num1List,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0,
									color: "#409eff"
								},
								{
									offset: 1,
									color: "#73c0de"
								}
							])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#2a6fc9"
									},
									{
										offset: 1,
										color: "#409eff"
									}
								])
							}
						},
						label: {
							show: true,
							position: isBarChart ? "top" : "top"
						},
						// 折线图特有配置
						smooth: !isBarChart,
						symbol: !isBarChart ? "circle" : "emptyCircle",
						symbolSize: !isBarChart ? 8 : 4
					},
					{
						name: "已完成数量",
						type: chartType,
						data: this.statisticData.num2List,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0,
									color: "#67c23a"
								},
								{
									offset: 1,
									color: "#95d475"
								}
							])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#4e9e2e"
									},
									{
										offset: 1,
										color: "#67c23a"
									}
								])
							}
						},
						label: {
							show: true,
							position: isBarChart ? "top" : "top"
						},
						// 折线图特有配置
						smooth: !isBarChart,
						symbol: !isBarChart ? "circle" : "emptyCircle",
						symbolSize: !isBarChart ? 8 : 4
					},
					{
						name: "撤单数量",
						type: chartType,
						data: this.statisticData.num3List,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{
									offset: 0,
									color: "#f56c6c"
								},
								{
									offset: 1,
									color: "#f8ad9d"
								}
							])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{
										offset: 0,
										color: "#e74c3c"
									},
									{
										offset: 1,
										color: "#f56c6c"
									}
								])
							}
						},
						label: {
							show: true,
							position: isBarChart ? "top" : "top"
						},
						// 折线图特有配置
						smooth: !isBarChart,
						symbol: !isBarChart ? "circle" : "emptyCircle",
						symbolSize: !isBarChart ? 8 : 4
					}
				]
			};

			try {
				// 设置图表选项 with null check
				if (this.chart && !this.chart.isDisposed()) {
					this.chart.setOption(option);
				}
			} catch (error) {
				console.error("Error setting chart option:", error);
			}
		},
		// Initialize chart and set up event listeners
		initChart() {
			// Get chart container
			const chartDom = document.querySelector(".statisticChart");
			if (chartDom) {
				// Initialize echarts instance
				this.chart = echarts.init(chartDom);
				// Set up resize listener with null check
				window.addEventListener("resize", () => {
					if (this.chart && !this.chart.isDisposed()) {
						this.chart.resize();
					}
				});

				// 添加图例选择事件监听器，确保至少有一个系列显示
				this.chart.off("legendselectchanged"); // 移除旧监听器防止重复绑定
				this.chart.on("legendselectchanged", (params) => {
					const selected = params.selected;
					let selectedCount = 0;
					let lastSelected = null;

					// 统计当前选中的数量和最后一个选中的项
					for (const key in selected) {
						if (selected[key]) {
							selectedCount++;
							lastSelected = key;
						}
					}

					// 如果没有选中任何项，强制选中最后一个选中的项
					if (selectedCount === 0 && lastSelected) {
						this.chart.dispatchAction({
							type: "legendSelect",
							name: lastSelected
						});
					}
				});
			}
		},
		//获取统计数据
		GetStoreOrderDayStatistic() {
			GetStoreOrderDayStatistic(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						if (res.data) {
							this.statisticData.storeList = [];
							this.statisticData.num1List = [];
							this.statisticData.num2List = [];
							this.statisticData.num3List = [];
							let list = res.data.dtls;
							list.forEach((item) => {
								this.statisticData.storeList.push(item.xName);
								this.statisticData.num1List.push(item.count1);
								this.statisticData.num2List.push(item.count2);
								this.statisticData.num3List.push(item.count3);
							});
							// 数据更新后刷新图表 with proper check
							if (this.chart && !this.chart.isDisposed()) {
								// 调用changeChartType方法重新渲染整个图表，确保图表类型、标题等配置也能正确更新
								this.changeChartType();
							} else if (!this.chart) {
								// If chart instance doesn't exist, create one first
								this.initChart();
								this.changeChartType();
							}
						}
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				})
				.finally(() => {
					this.loading = false;
				});
		},
		// 时间选择
		changeDate(val) {
			if (val) {
				this.formInline.year = parseInt(val.split("-")[0]);
				this.formInline.month = parseInt(val.split("-")[1]);
				this.formInline.day = parseInt(val.split("-")[2]);
			}
			this.GetStoreOrderDayStatistic();
		}
	}
};
</script>

<style scoped lang="scss">
.work_title_color {
	width: 5px;
	height: 20px;
	background-color: #409eff;
	display: inline-block;
	padding: 0;
	margin: 0;
}

.work_title {
	font-size: 16px;
	font-weight: 700;
	font-family: 微软雅黑;
	padding: 0;
	margin: 0;
	margin-left: 10px;
	display: inline-block;
}

.statisticChart {
	width: 100%;
	height: 600px;
	margin-top: 10px;
	padding-top: 20px;
	background-color: #fff;
	border-radius: 10px;
}
</style>
